const MK_MODULES = {
  ACTION_BUTTONS: "actionBtns",
  GOOGLE_MAP: "gmap",
  ORGANIZATIONAL_UNITS: "organization-units",
  VIDEO_STREAM: "video-stream"
};

export default MK_MODULES;
